import { MeaningfulPaintIntervalType } from '@watershed/constants/monitoring';
import { Teams } from '@watershed/constants/teams';
import { useOwner } from '@watershed/shared-frontend/hooks/useOwner';
import {
  MEANINGFUL_PAINT_PAGE_NAME,
  useStartMeaningfulPaintTimer,
} from '@watershed/shared-frontend/utils/frontendPerformanceMonitoring/measureMeaningfulPaint';

import ForbiddenPage from '../../components/ForbiddenPage';
import FlexibleProjectsPage from '../../components/projects/FlexibleProjectsPage';
import { hasPermissionsForMeasurementProjects } from '../../utils/featureAccess';
import { useUserContext } from '../../utils/UserContext';

/**
 * Starts timer when loading spinner begins until skeleton rendered.
 * Skeleton is only static content, so should load nearly immediately!
 * NOTE: this starts timer for either legacy or new page. Both handle
 * stopping the timer, but new page logs variable that it's "v2" too.
 */
function useObservabilityLogging() {
  useStartMeaningfulPaintTimer({
    pageName: MEANINGFUL_PAINT_PAGE_NAME.DI_MEASUREMENT_PROJECTS_PAGE,
    owner: Teams.DataIngestion,
    intervalType: MeaningfulPaintIntervalType.FirstLoadingInterval,
  });
}

export default function MeasurementProjects() {
  useOwner(Teams.DataIngestion);
  useObservabilityLogging();

  // Permissions and redirecting logic
  const userContext = useUserContext();
  const hasAccesssForMeasurementProjects =
    hasPermissionsForMeasurementProjects(userContext);

  if (!hasAccesssForMeasurementProjects) {
    // TODO (bryan) I'd love to have `forceRedirect` logic available
    // client-side, but barring that, let's kick the customer out of this page
    // with a hard-refresh; it'll trigger `forceRedirect` on the server!
    return <ForbiddenPage />;
  }

  return <FlexibleProjectsPage />;
}
